export default __webpack_public_path__ + "static/media/giants2Klein.acc4e872.jpg";